import React, { Component } from 'react';
import styled from 'styled-components';
import Content from '../../common/Content';
// import Headline from '../../common/Headline';
// import AnimationContainer from '../../common/AnimationContainer';
import FadeAnimation from '../../common/FadeAnimation';
import mediaWidth, { Width } from '../../utils/mediaWidth/mediaWidth';
import HorizontalSliderTalents from '../HorizontalSliderTalents';
import OtherTalents from '../OtherTalents';

class OurTalents extends Component {
    render() {
        const { className } = this.props;

        return (
            <Root className={className}>
                {/* <Content>
                    <FadeAnimation>
                        <Headline>Наши таланты</Headline>
                    </FadeAnimation>
                </Content> */}
                <StyledContent>
                    <HorizontalScrollWrapper>
                        <HorizontalSliderTalents />
                    </HorizontalScrollWrapper>
                </StyledContent>
                <Content>
                    <OtherWrapper>
                        <OtherTalents />
                    </OtherWrapper>
                </Content>
            </Root>
        );
    }
}

const Root = styled.div`
    padding-top: 163px;
    padding-bottom: 64px;
    
    background-color: #F5F5F5;
    
    ${mediaWidth.m} {
        padding-top: 311px;
        padding-bottom: 96px;        
    }
    
    ${mediaWidth.l} {
        padding-top: 96px;  
    }
`;

const StyledContent = styled(Content)`
    @media (max-width: ${Width.L - 1}px) {
        padding: 0;
        max-width: 100%;
    }
`;

const HorizontalScrollWrapper = styled(FadeAnimation)`
    margin-top: 40px;
    margin-bottom: 32px;
    
    ${mediaWidth.m} {
        margin-top: 56px;
        margin-bottom: 48px;
    }
    ${mediaWidth.l} { padding-left: 0; }
`;

const OtherWrapper = styled(FadeAnimation)`
    margin-top: 32px;
    
    ${mediaWidth.m} {
        margin-top: 48px;
    }
`;

export default OurTalents;
